module.exports = __webpack_public_path__ + "static/media/_T13-Illustrator.047816d2.svg";